module.exports = {
  project: {
    finalStatusReached: {
      ok: 'Der Projekt-Zustand hat einen endgültigen Zustand erreicht.',
      nok: 'Beim Projekt-Zustand muss eine Entscheidung getroffen werden.',
    },
    titleSet: {
      ok: 'Das Projekt hat einen Titel.',
      nok: 'Das Projekt hat noch keinen Titel.',
    },
    customerSet: {
      ok: 'Das Projekt hat einen Kunden zugewiesen bekommen.',
      nok: 'Das Projekt hat noch keinen Kunden zugewiesen bekommen.',
    },
    customerActive: {
      ok: 'Der Zugewiesene Kunde ist aktiv.',
      nok: 'Der Zugewiesene Kunde ist nicht aktiv.',
    },
    customerConfirmed: {
      ok: 'Die Daten des zugewiesenen Kunden wurden bereits bestätigt.',
      nok: 'Die Daten des zugewiesenen Kunden wurden noch nicht bestätigt.',
    },
    customerHasNumber: {
      ok: 'Der zugewiesene Kunde hat bereits eine Kundennummer.',
      nok: 'Der zugewiesene Kunde hat noch keine Kundennummer.',
    },
    customerContactActive: {
      ok: 'Der Zugewiesene Kunden-Auftraggeber ist aktiv.',
      nok: 'Der Zugewiesene Kunden-Auftraggeber ist nicht aktiv.',
    },
    customerContactConfirmed: {
      ok: 'Die Daten des zugewiesenen Kunden-Auftraggebers wurden bereits bestätigt.',
      nok: 'Die Daten des zugewiesenen Kunden-Auftraggebers wurden noch nicht bestätigt.',
    },
    personInChargeSet: {
      ok: 'Das Projekt hat einen Sachbearbeiter zugewiesen bekommen.',
      nok: 'Das Projekt hat noch keinen Sachbearbeiter zugewiesen bekommen.',
    },
    personInChargeActive: {
      ok: 'Der zugewiesene Sachbearbeiter ist aktiv.',
      nok: 'Der zugewiesene Sachbearbeiter ist nicht aktiv.',
    },
    personInChargeIsInternal: {
      ok: 'Der zugewiesene Sachbearbeiter ist ein interner Mitarbeiter.',
      nok: 'Der zugewiesene Sachbearbeiter ist ein kein interner Mitarbeiter.',
    },
    projectTermsAvailable: {
      ok: 'Dieses Projekt hat bereits Termine.',
      nok: 'Dieses Projekt hat noch keine Termine.',
    },
  },
  projectTerm: {
    titleSet: {
      ok: 'Dieser Termin hat bereits einen Titel.',
      nok: 'Dieser Termin hat noch keinen Titel.',
    },
    locationSet: {
      ok: 'Dieser Termin hat bereits eine Location.',
      nok: 'Dieser Termin hat noch keine Location.',
    },
    timeRangeSet: {
      ok: 'Dieser Termin hat bereits einen Zeitraum.',
      nok: 'Dieser Termin hat noch keinen vollständigen Zeitraum.',
    },
    durationValid: {
      ok: 'Die Dauer dieses Termins ist gültig.',
      nok: 'Die Dauer dieses Termins ist ungültig.',
    },
    managerPresent: {
      ok: 'Dieser Termin hat bereits einen Crewleiter.',
      nok: 'Dieser Termin hat keinen Crewleiter via Mitarbeiter-, Job- oder Planstellen-Datensatz.',
    },
    projectTermJobsAvailable: {
      ok: 'Dieser Termin hat bereits Planstellen.',
      nok: 'Dieser Termin hat noch keine Planstellen.',
    },
    projectTermInFuture: {
      ok: 'Projekt-Termin liegt noch in der Zukunft.',
      nok: 'Projekt-Termin liegt in der Vergangenheit.',
    },
  },
  projectTermJob: {
    jobSet: {
      ok: 'Dieser Planstelle wurde bereits ein Job zugewiesen.',
      nok: 'Dieser Planstelle wurde noch kein Job zugewiesen.',
    },
    jobActive: {
      ok: 'Der zugewiesene Job ist aktiv.',
      nok: 'Der zugewiesene Job ist nicht aktiv.',
    },
    personSet: {
      ok: 'Dieser Planstelle wurde bereits eine Person zugewiesen.',
      nok: 'Dieser Planstelle wurde noch keine Person zugewiesen.',
    },
    timeRangeSet: {
      ok: 'Diese Planstelle hat bereits einen Zeitraum.',
      nok: 'Diese Planstelle hat noch keinen vollständigen Zeitraum.',
    },
    durationValid: {
      ok: 'Die Dauer dieser Planstelle ist gültig.',
      nok: 'Die Dauer dieser Planstelle ist ungültig.',
    },
    termToJobMaxDeltaHours: {
      ok: 'Der Zeitraum dieser Planstelle liegt innerhalb von 24 Stunden in der Vergangenheit oder Zukunft des zugeörigen Termin-Zeitraums.',
      nok: 'Der Zeitraum dieser Planstelle liegt mehr als 24 Stunden in der Vergangenheit oder Zukunft des zugeörigen Termin-Zeitraums.',
    },
    employeeActive: {
      ok: 'Der zugewiesene Mitarbeiter ist aktiv.',
      nok: 'Der zugewiesene Mitarbeiter ist nicht aktiv.',
    },
    personJobCapable: {
      ok: 'Die zugewiesene Person hat die nötigen Fähigkeiten um diesen Job auszuführen.',
      nok: 'Der zugewiesenen Person fehlen die nötigen Fähigkeiten um diesen Job auszuführen.',
    },
    contractorActive: {
      ok: 'Der zugewiesene Sub-Unternehmer ist aktiv.',
      nok: 'Der zugewiesene Sub-Unternehmer ist nicht aktiv.',
    },
    contractorConfirmed: {
      ok: 'Die Daten des zugewiesenen Sub-Unternehmers wurden bereits bestätigt.',
      nok: 'Die Daten des zugewiesenen Sub-Unternehmers wurden noch nicht bestätigt.',
    },
    restDaysViolation: {
      ok: 'Der zugewiesene Mitarbeiter arbeitet im Rahmen der maximal erlaubten aufeinander folgenden Tagen.',
      nok: 'Der zugewiesene Mitarbeiter arbeitet an zu vielen aufeinander folgenden Tagen.',
    },
    restHoursViolation: {
      ok: 'Die nötigen Ruhezeiten des zugewiesenen Mitarbeiters werden eingehalten.',
      nok: 'Die nötigen Ruhezeiten des zugewiesenen Mitarbeiters werden verletzt.',
    },
    overlappingTimeRange: {
      ok: 'Für den zugewiesenen Mitarbeiter wurden keine anderen Planstellen mit überlappenden Zeiträumen gefunden.',
      nok: 'Der zugewiesene Mitarbeiter kann nicht in mehreren Planstellen mit überlappenden Zeiträumen eingeteilt werden.',
    },
    absenceViolations: {
      ok: 'Der zugewiesene Mitarbeiter / Sub-Unternehmer steht zu dieser Zeit zur Verfügung.',
      nok: 'Der zugewiesene Mitarbeiter / Sub-Unternehmer steht zu dieser Zeit nicht zur Verfügung.',
    },
    employeeStatusOutDated: {
      ok: 'Der zugewiesene Mitarbeiter hat die letzten Kern-Daten-Änderungen bestätigt.',
      nok: 'Der zugewiesene Mitarbeiter hat die letzten Kern-Daten-Änderungen noch nicht bestätigt.',
    },
    externalEmployeeRevoked: {
      ok: 'Der zugewiesene Mitarbeiter hat die Planstelle nicht abgelehnt.',
      nok: 'Der zugewiesene Mitarbeiter hat die Planstelle abgelehnt.',
    },
    externalEmployeeRevokedOutDated: {
      ok: 'Der zugewiesene Mitarbeiter hat die Planstelle vor der letzten Kern-Daten-Änderung nicht abgelehnt.',
      nok: 'Der zugewiesene Mitarbeiter hat die Planstelle vor der letzten Kern-Daten-Änderung abgelehnt.',
    },
    multiEmployeeAssignment: {
      ok: 'Es wurden keine Mitarbeiter gefunden, die mehreren Planstellen mit überlappenden Zeiträumen in diesem Termin zugeordnet sind.',
      nok: 'Es wurden Mitarbeiter gefunden, die mehreren Planstellen mit überlappenden Zeiträumen in diesem Termin zugeordnet sind.',
    },
    shippingOrderTimeRangeValid: {
      ok: 'Die Zeiten dieser Planstelle für den Lieferschein wurden bereits eingetragen.',
      nok: 'Die Zeiten dieser Planstelle für den Lieferschein wurden noch nicht eingetragen.',
    },
    timeRegistrationTimeRangeValid: {
      ok: 'Die Zeiten dieser Planstelle für die Zeiterfassung wurden bereits eingetragen.',
      nok: 'Die Zeiten dieser Planstelle für die Zeiterfassung wurden noch nicht eingetragen.',
    },
  },
}